module.exports = __webpack_public_path__ + "static/media/chips.49db1252.jpg";